import { auth } from "../../firebaseConfig";
import { HttpException } from "../../models/exceptions";
import store from "../../store";
import { sleep } from "../system";

export async function getCompanyLegacyId(): Promise<string> {
  let legacyId = undefined;
  for (let i = 0; i < 10; i++) {
    await sleep(100);
    if ((legacyId = store.getState().company.activeCompany?.legacy_data?.id)) {
      break;
    }
  }

  if (!legacyId) {
    throw new HttpException("An error occurred while defining the legacyId.");
  }
  return legacyId;
}

export async function getToken() {
  const token = await auth?.currentUser?.getIdToken();
  if (!token) {
    throw new Error("An error occurred while getting the token");
  }
  return token;
}
